import { learnerGradeToken } from './learnerIdentity.js';
import { balancedRecommendation } from './balancedAssessmentRotation.js';

const normalized = value => String(value ?? '').trim();

export const sessionBelongsToLearner = (session, learnerAlias, gradeName, accessCode = '') => (
  (session?.learnerAccountId != null && accessCode
    ? normalized(session.accessCode) === normalized(accessCode)
    : normalized(session?.learnerAlias || session?.studentName) === normalized(learnerAlias)) &&
  (learnerGradeToken(session?.actualGradeLevel) || normalized(session?.actualGradeLevel)) ===
    (learnerGradeToken(gradeName) || normalized(gradeName))
);
export const unfinishedAssessmentIdsForLearner = (sessions, learnerAlias, gradeName, accessCode = '') =>
  new Set((Array.isArray(sessions) ? sessions : [])
    .filter(session => sessionBelongsToLearner(session, learnerAlias, gradeName, accessCode))
    .map(session => normalized(session?.assessmentId)).filter(Boolean));

/**
 * Chooses the next assessment after a completed attempt.
 *
 * The server's recommendation remains authoritative. We only prevent a newly
 * completed assessment from immediately repeating when another eligible choice
 * exists, and we never recommend an assessment with an unfinished attempt for
 * this exact learner and grade.
 */
export const recommendAfterCompletion = ({
  assessments,
  sessions,
  learnerAlias,
  gradeName,
  completedAssessmentId,
  accessCode,
}) => {
  const catalog = Array.isArray(assessments) ? assessments : [];
  const unfinishedAssessmentIds = unfinishedAssessmentIdsForLearner(
    sessions,
    learnerAlias,
    gradeName,
    accessCode
  );
  const completedId = normalized(completedAssessmentId);
  const hasDifferentEligibleAssessment = catalog.some(assessment => {
    const id = normalized(assessment?.id);
    return id && id !== completedId && !unfinishedAssessmentIds.has(id);
  });
  const blockedAssessmentIds = new Set(unfinishedAssessmentIds);
  if (completedId && hasDifferentEligibleAssessment) blockedAssessmentIds.add(completedId);

  return {
    assessment: balancedRecommendation(catalog, blockedAssessmentIds),
    unfinishedAssessmentIds,
  };
};
